module.exports = __webpack_public_path__ + "static/3ds_benefits2-7407c672c3e16807c4565d4498516cf9.png";